module.exports = __webpack_public_path__ + "img/simg.b7f2d20c.png";